import React from 'react';
import { CouponInputV2 } from '@fff-web/fff-payments';
import { Collapsible } from '../Collapsible';
import styles from './CouponCodeField.module.scss';
import type { UseCouponCodeInterface } from '@fff-web/fff-payments';

type CouponCodeFieldPropsType = UseCouponCodeInterface & {
  handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  plan: string;
};

const LABEL = 'Got a Coupon Code?';
const SUCCESS_MESSAGE = 'Coupon applied';
const INPUT_PLACEHOLDER = 'Enter Promo Code';

const CouponCodeField = ({
  coupon,
  price,
  initialCouponCode,
  handleReturnPrice,
  handleOnChange,
  handleSubmit,
  plan,
  resetInput,
}: CouponCodeFieldPropsType) => {
  const discount = price?.now?.discount;
  const showSuccessMessage = parseFloat(discount) > 0;
  const openCollapsible = !!initialCouponCode;

  return (
    <div className={styles.wrapper}>
      <Collapsible title={LABEL} isOpen={openCollapsible}>
        <CouponInputV2
          initialCouponCode={initialCouponCode}
          coupon={coupon}
          handleOnChange={handleOnChange}
          handleSubmit={handleSubmit}
          plan={plan}
          handleReturnPrice={handleReturnPrice}
          placeholder={INPUT_PLACEHOLDER}
        />
        {showSuccessMessage && (
          <div className={styles.couponSelector}>
            <p className={styles.titleCorrect}>{SUCCESS_MESSAGE}</p>
            <button
              role="button"
              className={styles.buttonClose}
              onClick={resetInput as unknown as React.MouseEventHandler<HTMLButtonElement>}
            >
              <i className={`${styles.closeIcon} fas fa-times`} />
            </button>
          </div>
        )}
      </Collapsible>
    </div>
  );
};

export { CouponCodeField, LABEL, SUCCESS_MESSAGE, INPUT_PLACEHOLDER };
export type { CouponCodeFieldPropsType };
